import { Component } from '@angular/core';

import { NavController } from 'ionic-angular';

import { NotificacoesPage } from '../../pages/notificacoes/notificacoes';

import { Storage } from '@ionic/storage';

/**
 * Generated class for the NotificacaoComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'notificacao',
  templateUrl: 'notificacao.html'
})
	
export class NotificacaoComponent {

	badge = 0;
	exibeNot = false;

	constructor(public navCtrl: NavController, public storage: Storage)
	{
		this.storage.get('badge').then((val) => {
			if((val > 0)&&(val != ''))
			{
				this.badge = val;
				this.exibeNot = true;
			}
		});
	}

	notificacoes()
	{
		this.navCtrl.push(NotificacoesPage);
	}
}



// WEBPACK FOOTER //
// ./src/components/notificacao/notificacao.ts